webpackJsonp([113447729460612],{

/***/ 357:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"edges":[{"node":{"excerpt":"This is a test to cascade If we have a bunch of successive calculations, does it do the math correctly? then and","frontmatter":{"title":"Cascading","author":"Jacob Bolda"},"fields":{"slug":"/cascade/"}}},{"node":{"excerpt":"Double Interpolation Your data is laid out as below: p y1 y y2 x1 q11 q12 x p x2 q21 q22 which is run through the equation: This should…","frontmatter":{"title":"Double Interpolation","author":"Jacob Bolda"},"fields":{"slug":"/double-interpolation/"}}},{"node":{"excerpt":"Net Pressure When e = 0,","frontmatter":{"title":"Net Pressure","author":"Jacob Bolda"},"fields":{"slug":"/foundations/net-pressure/"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---calc-f1851d6ddcacb676fd74.js